<template>
  <div class="w-full d-flex align-center pb-2">
    <slot name="prefixo.topo" />

    <Filtros
      v-if="!ocultar_filtros_topo"
      :departamento_analise="departamento_analise"
      class="mr-10"
      @atualizacao:filtros="$emit('atualizacao:filtros', $event)"
    />

    <Colunas :headers="headers" @atualizacao:colunas-tabela="$emit('atualizacao:colunas-tabela', $event)" />

    <ExportacaoGridParaExcel
      v-if="habilitar_exportacao_excel"
      :items="items"
      :parametros_excel="parametros_excel"
    />

    <v-btn icon class="ml-5" @click="$emit('click:refresh', {})">
      <v-icon>mdi-refresh</v-icon>
    </v-btn>

    <div v-if="!ocultar_filtro_pesquisa" class="ml-5" style="width: 350px !important;">
      <v-text-field
        v-model="pesquisa"
        label="Pesquisar"
        hide-details
        outlined
        dense
        clearable
        prepend-inner-icon="mdi-magnify"
      />
    </div>

    <slot name="append.topo" />

    <v-spacer />

    <slot name="topo-lado-direito"></slot>

    <v-btn v-show="!tela_cheia && !ocultar_tela_cheia" icon @click="tela_cheia = !tela_cheia">
      <v-icon small>$Maximixar</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Filtros from "./Filtros";
import Colunas from "./Colunas";
import ExportacaoGridParaExcel from "./ExportacaoGridParaExcel";

export default {
  name: "TopoTabela",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  components: {
    ExportacaoGridParaExcel,
    Colunas,
    Filtros
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    ocultar_tela_cheia: {
      type: Boolean,
      default: false
    },
    departamento_analise: {
      type: Object,
      default: () => ({})
    },
    habilitar_exportacao_excel: Boolean,
    parametros_excel: Object,
    headers: Array,
    items: Array,
    ocultar_filtros_topo: Boolean,
    ocultar_filtro_pesquisa: Boolean,
  },
  data: () => ({
    pesquisa: '',
  }),
  computed: {
    tela_cheia: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        this.$emit('update:modelValue', valor);
      }
    },
  },
  watch: {
    pesquisa(valor) {
      this.$emit("atualizacao:pesquisa", valor);
    }
  }
}
</script>

<style scoped>
</style>
